import { useTranslation } from 'react-i18next';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ReactComponent as OpenTerminalIcon } from '~/assets/images/open-terminal.svg';
import SSOLink from '~/components/SSOLink';
import OpenTerminalSafariTooltip from '~/Nova/scenes/HostingList/components/OpenTerminalSafariTooltip';
import useIsConsoleAccessDisabled from '~/Nova/scenes/HostingList/scenes/SelfManagedHosting/hooks/useIsConsoleAccessDisabled';

import { systemConsoleData } from '../../../../utils/constants';

interface BrowserTerminalCardProps {
  hostingId: string;
  canShow: boolean;
}

export const BrowserTerminalCard = ({
  hostingId,
  canShow,
}: BrowserTerminalCardProps) => {
  const { t } = useTranslation('selfManagedHosting', {
    keyPrefix: 'access',
  });

  const isTerminalAccessDisabled = useIsConsoleAccessDisabled(
    hostingId,
    'terminal',
  );

  return (
    <Card data-testid="browser-terminal-card">
      <Stack sx={{ height: '100%' }} spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <OpenTerminalIcon />
          <Typography variant="h4">{t('browserTerminal')}</Typography>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
          {t('browserTerminalDescription')}
        </Typography>

        <OpenTerminalSafariTooltip>
          <SSOLink
            type={systemConsoleData.type}
            queryParams={{
              ...systemConsoleData.queryParams,
              app: 'ssh',
            }}
            fluid
            variant="contained"
            hostingId={hostingId}
            size="small"
            disabled={!canShow || isTerminalAccessDisabled}
          >
            <Typography variant="h3">{t('browserButtonText')}</Typography>
          </SSOLink>
        </OpenTerminalSafariTooltip>
      </Stack>
    </Card>
  );
};
